
	import { Component, Vue } from 'vue-property-decorator';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';

	enum BtnTypes {
		Link = 'link',
		Info = 'info',
		Danger = 'danger',
		Primary = 'primary',
		Success = 'success',
		Warning = 'warning'
	}

	@Component({
		components: { ViewportWrapper }
	})
	export default class TheNavPanel extends Vue {
		protected navPanelState: boolean = false;
		protected buttons: Array<APS.IModalDialogButton> = [
			{
				id: 'prevNav',
				type: BtnTypes.Info,
				title: 'Back',
				isBusy: false,
				busyLabel: 'Loading',
				autoBusy: false,
				visible: false,
				disabled: false,
				onClick: () => {
					//@ts-ignore
					window.aps.app.onPrev();
				}
			},
			{
				id: 'nextNav',
				type: BtnTypes.Primary,
				title: 'Next',
				isBusy: false,
				busyLabel: 'Loading',
				autoBusy: false,
				visible: false,
				disabled: false,
				onClick: () => {
					//@ts-ignore
					window.aps.app.onNext();
				}
			},
			{
				id: 'submitNav',
				type: BtnTypes.Primary,
				title: 'Submit',
				isBusy: false,
				busyLabel: 'Loading',
				autoBusy: false,
				visible: false,
				disabled: false,
				onClick: () => {
					//
				}
			},
			{
				id: 'cancelNav',
				type: BtnTypes.Danger,
				title: 'Cancel',
				isBusy: false,
				busyLabel: 'Loading',
				autoBusy: false,
				visible: false,
				disabled: false,
				onClick: () => {
					//
				}
			}
		];

		protected get showNavigationPanel(): boolean {
			return this.navPanelState && !!this.buttons.filter((button) => button.visible).length;
		}

		protected controlsGridStyle: Partial<CSSStyleDeclaration> = {
			width: '100%',
			height: 'auto',
			display: 'inline-grid',
			gridTemplateAreas: "'cancelNav . submitNav prevNav nextNav'",
			gridTemplateColumns: 'min-content 1fr min-content min-content min-content'
		};

		protected created(): void {
			window.addEventListener('HOST-NAV-PANEL-STATE' as never, this.setState);
			window.addEventListener('HOST-NAV-PANEL-SET-CONTROLS' as never, this.setControls);
		}

		protected beforeDestroy(): void {
			window.removeEventListener('HOST-NAV-PANEL-STATE' as never, this.setState);
			window.removeEventListener('HOST-NAV-PANEL-SET-CONTROLS' as never, this.setControls);
		}

		protected itemsStyles: Common.IMap<Partial<CSSStyleDeclaration>> = {};

		protected setState(event: { detail: { navPanelState: boolean } }): void {
			this.navPanelState = event.detail.navPanelState;
		}

		protected async handleButtonClick(button: APS.IModalDialogButton, event: PointerEvent): Promise<void> {
			button.onClick();
			await this.$nextTick();
			const el = event.target as HTMLElement | null;
			el?.blur();
		}

		protected setControls(event: { detail: { controls: Array<APS.IModalDialogButton> } }): void {
			const { controls } = event.detail;
			const propsToUpdate = ['isBusy', 'title', 'visible', 'disabled', 'onClick'] as Array<
				Partial<keyof APS.IModalDialogButton>
			>;

			this.buttons.forEach((button) => {
				const control = controls.find((item) => item.id === button.id);

				if (control) {
					propsToUpdate.forEach((prop) => {
						if (control.hasOwnProperty(prop)) {
							button[prop] = control[prop as never];
						}
					});

					button.type = control.type === BtnTypes.Success ? BtnTypes.Primary : control.type;
				}
			});
		}
	}
